module.exports = __webpack_public_path__ + "media/images/noticia03-4-e56dc5ec1db4a68a542ae64e2c9a0202.jpeg";